
import React from 'react';
import Logo from './Logo';

const Footer: React.FC = () => {
  return (
    <footer className="w-full py-8 px-6 border-t border-border/40">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="space-y-4">
          <Logo />
          <p className="text-sm text-muted-foreground">
            The simplest way to schedule meetings. Create a booking link in under 2 minutes.
          </p>
        </div>
        
        <div className="space-y-4">
          <h4 className="font-medium text-sm">Resources</h4>
          <ul className="space-y-2">
            <li><a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Help Center</a></li>
            <li><a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Blog</a></li>
            <li><a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Pricing</a></li>
          </ul>
        </div>
        
        <div className="space-y-4">
          <h4 className="font-medium text-sm">Legal</h4>
          <ul className="space-y-2">
            <li><a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</a></li>
            <li><a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Terms of Service</a></li>
          </ul>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto mt-8 pt-8 border-t border-border/40 text-center text-sm text-muted-foreground">
        &copy; {new Date().getFullYear()} CitaLoo. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
